import common from './en/pages/common';
import auth from './en/pages/auth';
import collaborators from './en/pages/collaborators';
import dashboard from './en/pages/dashboard';
import tasks from './en/pages/tasks';
import guests from './en/pages/guests';
import budget from './en/pages/budget';
import timeline from './en/pages/timeline';
import vendors from './en/pages/vendors';
import account from './en/pages/account';
import subscription from './en/pages/subscription';
import events from './en/pages/events';
import notifications from './en/pages/notifications';
import access from './en/pages/access';
import venue from './en/pages/venue';
import languages from './en/pages/languages';
import settings from './en/pages/settings';

import legal from './en/pages/legal';
import achievements from './en/pages/achievements';
import invitation from './en/pages/invitation';
import theme from './en/theme';
import taskTemplates from './en/taskTemplates';
import debug from './en/debug';

export default {
  ...common,
  common,
  currentEvent: "Current Event",
  auth,
  collaborators,
  dashboard,
  tasks,
  guests,
  budget,
  timeline,
  vendors,
  account,
  subscription,
  events,
  notifications,
  access,
  venue,
  languages,
  ...settings,
  legal,
  achievements,
  invitation,
  theme: {
    ...theme,
    light: "Light",
    dark: "Dark",
    system: "System"
  },
  taskTemplates,
  debug
};
